type Environment = "dev" | "ppe" | "prod" | "local";

type ClientConfig = {
  endpoint: string;
  instrumentationKey: string;
  webChatTokenEndpoint: string;
  webAgentEnvironmentId: string;
  webAgentBotSchema: string;
};

type ClientConfigs = {
  [key in Environment]: ClientConfig;
};

// Power Virtual Agents / Copilot Studio Direct Line token endpoints.
//
// We have three Power Platform environments wired up:
//   * dining-agent-dev   — dev bot, SSO via Microsoft Entra ID.
//   * dining-agent-ppe   — pre-prod bot, SSO via Microsoft Entra ID.
//   * dining-agent-prod  — production bot, SSO via Microsoft Entra ID.
//
// Hostname pattern:
//   https://<first-30-hex-of-env-id>.<last-2-hex-of-env-id>.environment.api.powerplatform.com
// To find a new env's URL: open https://copilotstudio.microsoft.com → switch
// to the target environment → bot → Settings → Channels → Custom website.
const WEBCHAT_TOKEN_URL_DEV =
  "https://70e09792fa19e4ca846a6048195d8b.1c.environment.api.powerplatform.com/powervirtualagents/botsbyschema/copilots_header_82780/directline/token?api-version=2022-03-01-preview";
const WEBCHAT_TOKEN_URL_PPE =
  "https://b889a05122a6e60eafa909da31db68.00.environment.api.powerplatform.com/powervirtualagents/botsbyschema/copilots_header_82780/directline/token?api-version=2022-03-01-preview";

const WEBCHAT_TOKEN_URL_PROD =
  "https://bd1b6249ed3ee15cbf9502272a5b16.0e.environment.api.powerplatform.com/powervirtualagents/botsbyschema/copilots_header_82780/directline/token?api-version=2022-03-01-preview";

// Copilot Studio agent with Entra ID authentication ("Authenticate with Microsoft").
// Consumed by WebAgent.tsx via the official @microsoft/agents-copilotstudio-client
// package, which talks to the Copilot Runtime (Direct-to-Engine) using an Entra
// bearer token carrying the CopilotStudio.Copilots.Invoke permission — no Direct
// Line channel or SSO card flow needed.
// Schema: copilots_header_82780
// Agent App ID: 33053769-b746-4e13-8707-9fd40f3fe31b
// Tenant: 72f988bf-86f1-41af-91ab-2d7cd011db47

const clientConfigs: ClientConfigs = {
  prod: {
    endpoint: "https://prod-dining-api-frontdoor.azurefd.net",
    instrumentationKey: "7c931884-62a0-49ec-8875-f4a5869219bd",
    webChatTokenEndpoint: WEBCHAT_TOKEN_URL_PROD,
    webAgentEnvironmentId: "bd1b6249-ed3e-e15c-bf95-02272a5b160e",
    webAgentBotSchema: "copilots_header_82780",
  },
  ppe: {
    endpoint: "https://ppe-dining-api-frontdoor.azurefd.net",
    instrumentationKey: "c232118a-911c-4470-8744-2d8ee6c8f1db",
    webChatTokenEndpoint: WEBCHAT_TOKEN_URL_PPE,
    webAgentEnvironmentId: "b889a051-22a6-e60e-afa9-09da31db6800",
    webAgentBotSchema: "copilots_header_82780",
  },
  dev: {
    endpoint: "https://dev-dining-api-frontdoor.azurefd.net",
    instrumentationKey: "7c6f8a96-029a-4cd2-8d20-7227d5f061a9",
    webChatTokenEndpoint: WEBCHAT_TOKEN_URL_DEV,
    webAgentEnvironmentId: "70e09792-fa19-e4ca-846a-6048195d8b1c",
    webAgentBotSchema: "copilots_header_82780",
  },
  local: {
    endpoint: "https://dev-dining-api-frontdoor.azurefd.net",
    instrumentationKey: "7c6f8a96-029a-4cd2-8d20-7227d5f061a9",
    webChatTokenEndpoint: WEBCHAT_TOKEN_URL_DEV,
    webAgentEnvironmentId: "70e09792-fa19-e4ca-846a-6048195d8b1c",
    webAgentBotSchema: "copilots_header_82780",
  },
};

export const config: ClientConfig = {
  endpoint: clientConfigs[(process.env.APP_ENV as Environment) || "dev"].endpoint,
  instrumentationKey:
    clientConfigs[(process.env.APP_ENV as Environment) || "dev"].instrumentationKey,
  webChatTokenEndpoint:
    clientConfigs[(process.env.APP_ENV as Environment) || "dev"].webChatTokenEndpoint,
  webAgentEnvironmentId:
    clientConfigs[(process.env.APP_ENV as Environment) || "dev"].webAgentEnvironmentId,
  webAgentBotSchema: clientConfigs[(process.env.APP_ENV as Environment) || "dev"].webAgentBotSchema,
};
